import { useEffect, useState } from 'react';
import type { EpisodeCategory } from '../../../../../common/enums/episodeCategory';
import type { IEpisodeCategoryBasic } from '../../../../../common/interfaces/episodeCategory';
import type { IServicesByServiceGroupForEpisodeCategory } from '../../../../../common/interfaces/servicesByServiceGroupForEpisodeCategory';
import type { ISelectableCard } from '../../organizations/organizationAddCarePath/OrganizationAddCarePathContent';
import { translateKey } from '../../../../translate';
import { SelectableOptionsCard } from '../cards/SelectableOptionsCard';

interface IChooseEpisodeCategoryProps {
    episodeCategory?: IEpisodeCategoryBasic;
    serviceGroupMembershipsGroupedByEpisodeCategories: IServicesByServiceGroupForEpisodeCategory[];
    updateState: (episodeCategory?: IEpisodeCategoryBasic) => void;
}

export function ChooseEpisodeCategory(props: IChooseEpisodeCategoryProps) {
    const [card, setCard] = useState<ISelectableCard>();

    useEffect(() => {
        createChooseEpisodeCategoryCard();
    }, [props.episodeCategory]);

    if (!card) {
        return null;
    }

    return (
        <SelectableOptionsCard
            {...card}
            onChange={onChange}
        />
    );

    function onChange(id: string, _sequence: number) {
        const selectableOption = card?.selectableOptions.find((option) => option.id === id);
        props.updateState(selectableOption ? { id, name: selectableOption.name as EpisodeCategory } : undefined);
    }

    function createChooseEpisodeCategoryCard() {
        if (props.serviceGroupMembershipsGroupedByEpisodeCategories.length > 0) {
            const selectableOptions = props.serviceGroupMembershipsGroupedByEpisodeCategories.map((category) => ({
                name: category.episodeCategory.name,
                displayName: translateKey(`episodeCategoryEnum.${category.episodeCategory.name}`),
                id: category.episodeCategory.id,
                selected: props.episodeCategory?.name === category.episodeCategory.name,
            }));

            const episodeCategoryCard: ISelectableCard = {
                title: translateKey('carePath.whichCarePathToAdd'),
                sequence: 0,
                selectableOptions,
            };

            setCard(episodeCategoryCard);
        }
    }
}
